import logo from "./interactive-card-details-form-main/images/card-logo.svg";

const Display = ({ cardName, cardNumber, cvc, mm, yy }) => {
    return ( 
        <div className="display success-animation">
            <div className="card-backview">
                <div className="blackline"></div>
                <div className="cvc">
                    <p>{cvc}</p>
                </div>
                <div className="copyright">
                    <div className="one">
                        <div className="long"></div>
                        <div className="semi"></div>
                        <div className="semi"></div>
                        <div className="dot"></div>
                    </div>
                    <div className="two">
                        <div className="short"></div>
                        <div className="semi"></div>
                        <div className="long"></div>
                        <div className="dot"></div>
                    </div>
                    <div className="three">
                        <div className="short"></div>
                        <div className="semi"></div>
                        <div className="long"></div>
                        <div className="dot"></div>
                    </div>
                </div>
            </div>

            <div className="card-frontview">
                <div className="logo">
                    <img src={logo} alt="logo" />
                </div>
                <div className="card-number">
                    <p>{cardNumber}</p>
                </div>
                <div className="card-name">
                    <span className="name">{cardName}</span>
                    <span className="expiry-date">{mm}/{yy}</span>
                </div>
            </div>
        </div>
     );
}
 
export default Display;